export default __webpack_public_path__ + "static/media/050_brake.a51c8bac.mp4";